import { Controller } from "@hotwired/stimulus"

// Attached to pages embedded on third-party sites via iframe (external referral
// form, create button, confirmation). Posts the content height to the parent
// window so the host site's embed snippet (see admin > referral form configs >
// embed code) can resize the iframe to fit. With scroll-parent-value="true",
// also asks the parent to scroll the iframe into view — used by the
// confirmation page, which renders much shorter than the form that preceded it.
export default class extends Controller {
  static values = { scrollParent: Boolean }

  connect() {
    if (window.parent === window) return

    this.postHeight()
    this.resizeObserver = new ResizeObserver(() => this.postHeight())
    this.resizeObserver.observe(this.element)

    if (this.scrollParentValue) {
      window.parent.postMessage({ sindi: "embed", type: "scroll-to-top" }, "*")
    }
  }

  disconnect() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
  }

  postHeight() {
    const height = Math.ceil(this.element.getBoundingClientRect().bottom + window.scrollY + 32)
    window.parent.postMessage({ sindi: "embed", type: "resize", height: height }, "*")
  }
}
